import { CaretSvg, Icon, IconSize } from '@spritz-finance/ui'
import { motion } from 'framer-motion'
import styled, { CSSProperties } from 'styled-components'

const StyledMotionContainer = styled(motion.div)`
    &:hover {
        cursor: pointer;
    }
`

export const ExpandDetailIcon = ({
    active,
    style,
    size,
    tint,
    className,
    onClick,
}: {
    active: boolean
    style?: CSSProperties
    size?: IconSize
    tint?: string
    className?: string
    onClick?: () => void
}) => {
    const state = active ? 'expanded' : 'collapsed'
    const variants = {
        collapsed: { rotate: 0 },
        expanded: { rotate: 180 },
    }
    return (
        <StyledMotionContainer
            initial={state}
            animate={state}
            variants={variants}
            onClick={() => onClick?.()}
            style={style}
            className={className}
        >
            <Icon size={size} icon={CaretSvg} tint={tint} />
        </StyledMotionContainer>
    )
}
